
// gestione della rotta da ripristinare dopo il login.
// serve a chi apre l'app direttamente su una pagina interna (scorciatoia iOS
// sulla home, link condiviso, PWA con start_url dedicato): senza questo,
// dopo l'autenticazione si finirebbe sempre sulla home di default.

const STORAGE_KEY = "postLoginRedirect";

// accetta solo path interni: "/qualcosa".
// esclude "//host" e "/\host" che il browser interpreterebbe come URL assoluti.
function isSafeInternalPath(path) {
    return typeof path === "string"
        && path.startsWith("/")
        && !path.startsWith("//")
        && !path.startsWith("/\\");
}

// memorizza la rotta richiesta prima di dirottare l'utente al login
export function savePostLoginRedirect(path) {
    if (!isSafeInternalPath(path) || path.startsWith("/login")) return;
    try {
        sessionStorage.setItem(STORAGE_KEY, path);
    } catch {
        // storage non disponibile (safari privato): si ripiega sul default
    }
}

// restituisce la rotta salvata e la consuma, così un login successivo
// non riporta l'utente su una pagina vecchia
export function consumePostLoginRedirect() {
    try {
        const path = sessionStorage.getItem(STORAGE_KEY);
        sessionStorage.removeItem(STORAGE_KEY);
        return isSafeInternalPath(path) ? path : null;
    } catch {
        return null;
    }
}
